<template>
    <div class="monitors">
        <div class="body">
            <div class="map-page-guide">Outros Fornecedores</div>
            <div class="map-page-title">Outros Fornecedores</div>
            <cc-loader-full v-if="loading" />
            <div class="explore-inputs-container">
                <StandardInput class="mobile-width" :title="'Estado'" :type="'select'"
                    :action="(evt) => filter_state(evt)" :list="formatStatesList(statusStates)" />
                <StandardInput
                    class="mobile-width"
                    :title="'Cidade'"
                    :type="'select'"
                    :action="(evt) => setCity(evt)"
                    :list="formatStatesList(cities)" />
                <StandardInput
                    class="mobile-width"
                    :title="'Odenar por'"
                    :type="'select'"
                    :action="(val) => load({ ...filters, order: val })"
                    :list='[
                        { text: "Nome", value: "for_nome" },
                        { text: "Participação", value: "participation" },
                        { text: "Qtd. Vendedores", value: "sellers_count" },
                    ]' />
                <StandardInput
                    class="mobile-width"
                    :title="'Ordenação'"
                    :type="'select'"
                    :action="(val) => load({ ...filters, order_direction: val })"
                    :list='[
                        { text: "Menor->Maior", value: "ASC" },
                        { text: "Maior->Menor", value: "DESC" },
                    ]' />
                <StandardInput class="mobile-width" :title="'Fornecedor'" :type="'text'"
                    :action="(val) => load({ ...filters, name: val })" />
                <p class="count">Fornecedores: {{ total }}</p>
                <button class="btn btn-success" @click="export_xls">Baixar Excel</button>
            </div>

            <div class="page-table-containear">
                <div class="page-table">
                    <div class="page-table-header not-print">
                        <div class="page-table-expand-width"></div>
                        <div class="page-table-store-width">Fornecedor</div>
                        <div class="page-table-cnpj-width desktop">CNPJ</div>
                        <div class="page-table-cnpj-width">Telefone</div>
                        <div class="page-table-state-width desktop">Estado</div>
                        <div class="page-table-city-width desktop">Cidade</div>
                        <div class="page-table-participation-width">Participação</div>
                        <div class="page-table-vendedores-width desktop">Vendedores</div>
                        <div class="page-table-date-width desktop">Ult. Oferta</div>
                        <div class="page-table-date-width desktop">Ult. Compra</div>
                    </div>
                    <div v-for="(seller, index) in providers" :key="seller.id">
                        <div class="page-table-line not-print" style="border-bottom: #E5E5E5 1px solid">
                            <div class="page-table-expand-width">
                                <!-- <span v-on:click="toggleIsExpanded(seller)" v-if="!seller.isExpanded" class="material-icons-outlined page-table-expand-icon">expand_more</span>
                                <span v-on:click="toggleIsExpanded(seller)" v-else class="material-icons-outlined page-table-expand-icon">expand_less</span> -->
                                <img class="provider-cover rounded" :src="seller.cover_url"
                                    v-if="seller.cover_url != 'https://via.placeholder.com/100x50/FFFFFFFF/ff7110/?text=CLUB'">
                                <span v-else class="material-icons page-table-user-icon">local_shipping</span>
                            </div>

                            <div class="page-table-store-width page-table-separator page-table-store">
                                <div class="seller-table-mobile-align">{{ seller.name }}</div>
                            </div>

                            <!-- desktop -->
                            <div class="page-table-cnpj-width page-table-separator desktop">
                                <div class="page-mobile-header">CNPJ</div>
                                {{ seller.cnpj | VMask('##.###.###/####-##') }}
                            </div>
                            <div class="desktop page-table-cnpj-width page-table-separator">
                                <div class="page-mobile-header">Telefone</div>
                                <a v-if="seller.phone" :href="'https://api.whatsapp.com/send?phone=' + formatNumber(seller.phone)"
                                    target="_blank"
                                    class="page-table-contact-text"
                                >{{ seller.phone | VMask("(##) ####-#####") }}</a>
                                <div v-else class="page-table-contact-text">(xx) xxxxx-xxxxx</div>
                            </div>
                            <!-- desktop -->
                            <div class="page-table-state-width page-table-separator  desktop">
                                <div class="page-mobile-header">Estado</div>
                                {{ seller.head_office ? seller.head_office.state.name : '--' }}
                            </div>
                            <!-- desktop -->
                            <div class="page-table-city-width  desktop">
                                <div class="page-mobile-header">Cidade</div>
                                {{ seller.head_office && seller.head_office.city ? seller.head_office.city.name : '--' }}
                            </div>
                            <!-- desktop -->
                            <div class="page-table-participation-width">
                                <div class="participation-container">
                                    <div class="participation-bar">
                                        <div class="participation-fill"
                                            :style="{ width: (seller.participation * 100) + '%' }"></div>
                                    </div>
                                    <span class="participation-text">{{ (seller.participation * 100).toFixed(1) }}%</span>
                                </div>
                            </div>
                            <div class="page-table-vendedores-width">
                                <span>{{ seller.sellers_count }}</span>
                            </div>
                            <div class="page-table-date-width desktop">
                                <span>{{ seller.last_offer_date ? new Date(seller.last_offer_date).toLocaleDateString('pt-BR') : '--' }}</span>
                            </div>
                            <div class="page-table-date-width desktop">
                                <span>{{ seller.last_purchase_date ? new Date(seller.last_purchase_date).toLocaleDateString('pt-BR') : '--' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <cc-paginacao
                    :key="'pag'"
                    classes="orange"
                    :items_by_page_value="items_by_page_value"
                    :total="total"
                    :page="page"
                    :page_limit="11"
                    v-on:change="load({ ...filters, page: $event })"></cc-paginacao>
                <a id="download-excel" style="display:none;"></a>
            </div>
        </div>
    </div>
</template>
<script>

import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon, LControl } from "vue2-leaflet";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { perm_mixin } from '@/mixins/permission.mixin'
import ProviderService from '@/services/v3/provider.service'
import StoreService from '@/services/v3/stores/store.service'
import StandardInput from '@/components/ui/inputs/StandardInput.vue'
import UserService from "@/services/v1/user.service";
import Paginacao from "@/components/cliente/base-components/Pagination";

export default {
    components: {
        LMap,
        LIcon,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
        LControl,
        StandardInput,
        ccPaginacao: Paginacao
    },
    mixins: [perm_mixin,],
    data() {
        return {
            svc: new ProviderService(),
            store_svc: new StoreService(),
            user_svc: new UserService(),
            allCities: [],
            cities: [],
            zoom: 10,
            items_by_page_value: 20,
            page: 1,
            filters: {
                name: '',
                unrelated: true
            },
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            toggle_width: 160,
            showParagraph: false,
            total: undefined,
            providers: [],
            stores: [],
            state: {},
            loading: true,
            showMap: true,
            selectedProvider: undefined,
            statusStates: []
        }
    },
    watch: {
        'filters.name': function (val) {
            let rx = new RegExp(val, 'gi')
            this.providers.forEach(p => p.visible = false)
            this.providers
                .filter(p => p.name.match(rx) || !val)
                .forEach(p => p.visible = true)
        }
    },
    computed: {
        head_office_state() {
            return this.stores.find(s => s.is_head_office).state.fu
        },
        valid_providers() {
            return this.providers
                .filter(p => (this.selectedProvider && this.selectedProvider == p) || !this.selectedProvider)
                .filter(p => p.visible)
        }
    },
    methods: {
        formatNumber(number) {
            if (!number) return null;
            number = number.replace("+", "").replace("(", "").replace(")", "").replace("-", "");
            if (number[0] + "" + number[1] != "55") number = "55" + number;
            return number;
        },
        filter_state(evt) {
            this.cities = this.allCities.filter(city => city.value.est_id == evt.value.est_id)
            this.state = evt.value
            this.load({ ...this.filters, state: evt.value.est_sigla })
        },
        selectProvider(p) {
            if (this.selectedProvider == p) this.selectedProvider = undefined
            else this.selectedProvider = p
        },
        setCity(evt) {
            this.loading = true
            this.load({ ...this.filters, city: evt.value.cid_nome })
        },
        load_stores() {
            this.store_svc.load().then(response => {
                this.stores = response.data
                const head = this.stores.find(s => s.is_head_office)
                this.load({ ...this.filters, state: head.state.fu })
            })
        },
        getStates() {
            this.user_svc.region_data().then(response => response.data).then(response => {
                let states = response.estados;
                this.allCities = response.cidades.map(city => { return { key: city.cid_nome, value: city } })
                let filtroStates = [];
                for (let index = 0; index < states.length; index++) {
                    filtroStates.push({
                        key: states[index].est_nome,
                        value: states[index]
                    })

                }
                this.statusStates = filtroStates;
            })
                .catch(error => {
                    this.is_loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });

        },
        export_xls() {
            this.svc.export_xls({ ...this.filters, export: true })
            .then(response => response.data)
            .then(data => {
                var file = new Blob([data], {type: 'application/vnd.ms-excel'});
                var fileURL = URL.createObjectURL(file);
                var el = document.getElementById("download-excel");
                el.download = "outros-vendedores.xlsx";
                el.href = fileURL;
                el.click();
                setTimeout(function(){
                    window.URL.revokeObjectURL(fileURL);
                }, 100);
            })
            .catch(error => {
                ErrorHandlerService.handle(error, this.$store);
            });
        },
        load(params) {
            this.loading = true
            this.filters = params
            this.svc.load_providers({ ...params }).then(response => {
                this.providers = response.data.data.filter(p => p.head_office)
                    .filter(p => p.head_office.geolocation)
                    .filter(p => !isNaN(p.head_office.geolocation.latitude))
                    .filter(p => !isNaN(p.head_office.geolocation.longitude)).map(p => { return { ...p, visible: true } })
                this.total = response.data.meta.total
                this.page = response.data.meta.current_page
                this.items_by_page_value = response.data.meta.per_page
                this.loading = false
            }).catch(error => {
                ErrorHandlerService.handle(error, this.$store);
            });
        },
        formatStatesList(list) {
            let response = []
            list.forEach(element => {
                response.push({
                    value: element,
                    text: element.key
                })
            });
            return response
        },
    },
    mounted() {
        this.getStates()
        this.load_stores()
    }
}
</script>

<style lang="scss" scoped>
    // @import './explore.page';
    @import '@/sass/commons/_tables';
    .cover-img img {
        width: 50px;
    }
    .map-controls {
        padding-top: 10px;
        margin: auto;
        padding-right: 10px;
        width: 170px;
    }
    .monitors {
        padding-bottom: 5vw;
    }
    .map-page-guide{
        font-weight: 400;
        font-size: 1em;
        color: #ABABAB;
    }
    .mobile-width{
        width: 20%;
    }
    .map-page-title{
        font-weight: 600;
        font-size: 2.25em;
        color: #605F5F;
        margin-top: 1vh;
        margin-bottom: 2vh;
    }
    .count{
        background-color: #2acd721a;
        padding: 1.4vh 0.5vw;
        border-radius: 8px;
        color: #30aa4c;
        font-weight: 300;
        font-size: 1.5em;
        margin: 0;
    }
    .explore-inputs-container{
        display: flex;
        gap: 6vw;
        align-items: flex-end;
        margin-bottom: 3vw;
    }
    .map-container{
        display: flex;
        justify-content: space-between;
        height: 80vh;
    }
    .map-view{
        height: 100%;
        z-index: 0;
        width: 70%;
    }
    .list-container{
        width: 25%;
        height: 100%;
        overflow: auto;
        padding: 0 2vw;
    }
    .line-container{
        padding: 0 0.5vw;
        margin-bottom: 2vw;
        border-radius: 8px;
        &:hover{
            outline: 1px solid var(--primary-color);
        }
    }
    .list-line{
        font-weight: 300;
        font-size: 1em;
        color: #605F5F;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    .line-title{
        font-weight: bold;
        font-size: 1.1em;
    }
    .selected-line{
        outline: 1px solid var(--primary-color);
    }
    .line-show-icon{
        color: gray;
    }
    .line-show-icon-active{
        color: var(--primary-color);
    }
    .email-field{
        width: 80%;
        text-align: end;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    @media only screen and (max-width: 800px) {
        .explore-inputs-container{
            flex-wrap: wrap;
            font-size: 0.7em;
        }
        .mobile-width{
            width: 45%;
        }
        .map-container{
            flex-direction: column;
            gap: 4vh;
        }
        .map-view{
            width: 100%;
            height: 90vh;
        }
        .list-container{
            width: 100%;
        }
    }
.provider-cover {
    width: 75px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        object-fit: fill;
        width: 100%;
        height: 100%;
    }
}

.page-route-select {
    display: flex;
    align-items: center;
}

.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    line-height: 17px;
    color: #ABABAB;
    margin-right: 20px;
    cursor: pointer;
}

.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}

.page {
    padding: 0 40px 70px 0;
    font-size: 1vw;
}

.page-head-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5vw;
}

.page-head-buttons-group {
    display: flex;
    gap: 2vw;
}

.offers-alert {
    background-color: #cce3eb;
    color: #4f4ff7;
    border-color: #4f4ff7;
}

.alert-container {
    padding: 1vh 0.5vw;
    font-weight: 300;
    font-size: 18px;
    border-radius: 8px;
    min-width: 20vw;
    text-align: center;
    cursor: pointer;
    border-style: solid;
    border-width: 0;
}

.active-alert {
    border-width: 1px;
}

.table-select-button {
    background-color: white;
    font-weight: 600;
    font-size: 1.1em;
    color: #202020;
    border-radius: 8px;
    width: 10vw;
    border: 0.5px solid #e5e5e5;
    line-height: 1;
    padding: 0.7vw 0;
}

.active-select-button {
    border-color: var(--primary-color);
    color: var(--primary-color);
}

.orders-alert {
    background-color: #2acd721a;
    color: #30aa4c;
    border-color: #30aa4c;
}

.total-alert {
    border-color: #FF5722;
    color: #FF5722;
    background-color: #FF57221a;
    min-width: 0;
    width: 10vw;
}

.table-select-container {
    display: flex;
    gap: 2vw;
    margin-top: 4vh;
}

.page-invite-button {
    display: flex;
    border: 0.5px solid #E5E5E5;
    border-radius: 8px;
    padding: 15px 12px;
}

.page-filter-containears {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 2vh;
}

.page-table-header {
    background: #FFFEFC;
    border: 0.5px solid #E5E5E5;
    font-weight: 600;
    font-size: 1.19em;
    color: #605F5F;
    display: flex;
    padding: 1vh 0;
    margin-top: 2vh;
}

.page-table-store-width {
    width: 22%;
}

.winners-page-options-select {
    position: absolute;
    z-index: 2;
    margin-top: 1vh;
    right: 0;
    padding: 0.5vw;
    border-radius: 5px;
    border: 1px solid #E5E5E5;
    background-color: white;
}

.winners-page-options-select-option {
    font-size: 1.25em;
    padding: 0.5vh;
    min-width: 15vw;
    text-align: end;
    cursor: pointer;
}

.winners-page-options-select-option:hover {
    background-color: var(--primary-color);
    border-radius: 5px;
    color: white;
}

.page-table-expand-icon {
    font-size: 3em;
    color: var(--primary-color);
    cursor: pointer;
}

.page-table-subheader {
    border: 0;
    border-bottom: #E5E5E5 1px solid;
    margin-top: 1vh;
    background-color: transparent;
}

.page-table-document-width {
    width: 12%;
    padding-left: 10px;
}

.page-table-contact-width {
    width: 13%;
    padding-left: 10px;
}

.page-table-cnpj-width {
    width: 13%;
    padding-left: 10px;
}

.page-table-state-width {
    width: 12%;
    padding-left: 10px;
}

.page-table-city-width {
    width: 14%;
    padding-left: 10px;
}

.page-table-participation-width {
    width: 12%;
    padding-left: 10px;
}

.page-table-vendedores-width {
    width: 12%;
    padding-left: 30px;
}

.page-table-date-width {
    width: 10%;
    padding-left: 10px;
}

.checkbox-container {
    display: flex;
    justify-content: space-between;
    width: 30%;
}

.table-not-typed {
    background-color: lightcoral;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    width: 80%;
    display: block;
}

.history-icon {
    color: green;
    margin-left: 5%;
    cursor: pointer;
}

.percent-orange {
    background-color: lightsalmon;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    width: 80%;
    display: block;
    text-transform: uppercase;
}

.table-typed {
    background-color: lightgreen;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    width: 80%;
    display: block;
    text-align: center;
}

.page-table-phone-width {
    width: 12%;
}

.page-table-rate-width {
    width: 8%;
}

.expanded-line {
    background: rgba(255, 113, 16, 0.10);
}

.page-table-email-width {
    width: 22%;
}

.page-table-action-width {
    width: 7%;
}

.seller-participation-icon {
    color: white;
    border-radius: 10px;
    padding: 0.5vh 0;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    width: 70%;
}

.page-table-expand-loading {
    height: 12vh;
    display: flex;
    align-items: center;
    justify-content: center;

}

.page-table-loading-icon {
    animation-name: spin;
    animation-duration: 2.5s;
    color: var(--primary-color);
    font-size: 4em;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.table-not-typed {
    background-color: lightcoral;
}

.percent-orange {
    background-color: lightsalmon;
}

.table-typed {
    background-color: lightgreen;
}

.page-table-status-width {
    width: 7%;
    text-align: center;
}

.page-table-status {
    display: flex;
    justify-content: center;
}

.page-table-actions-width {
    flex: 1;
    text-align: center;
}

.page-table-line {
    display: flex;
    font-weight: 300;
    font-size: 1em;
    color: #605F5F;
    margin-top: 1.5vh;
    align-items: center;
    padding: 1vh 0;
}

.page-table-store {
    display: flex;
    align-items: center;
}

.page-mobile-header {
    display: none;
}

.page-table-store-img {
    max-height: 40px;
    max-width: 40px;
}

.page-table-user-icon {
    font-size: 2em;
    color: rgb(164, 163, 163);
    width: 75px;
    text-align: center;
}

.page-table-contact {
    display: flex;
    align-items: center;
}

.page-table-contact-icon {
    color: white;
    background-color: green;
    border-radius: 50%;
    font-size: 1.7em;
    padding: 3px;
    margin-right: 10px;
}

.page-table-contact-text {
    color: green;
}

.page-table-block-width {
    width: 13%;
    display: flex;
}

.page-table-delete-icon {
    cursor: pointer;
    color: #CD2A2A;
}

.page-table-update-icon {
    cursor: pointer;
    color: blue;
}

.page-table-expand-width {
    width: 12%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.mobile {
    display: none;
}

.selected-value {
    display: flex;
    background: #FCF9F7;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: var(--primary-color);
    padding: 10px;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;
}

.selected-value-containear {
    display: flex;
    margin-top: 10px;
}

.selected-value-icon-close {
    font-size: 1.7em;
    margin-left: 15px;
}

.print-only {
    display: none;
}

.page-section-select-size {
    background-color: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 7.5vh;
    min-width: 12vw;
    padding: 0 1vw;
    display: flex;
    align-items: center;
    margin-right: 2vw;
}

.page-section-select-size:hover {
    background-color: #fdf0e9;
}

.page-section-select-size-active {
    cursor: default;
    border-radius: 8px 8px 8px 8px;
    background-color: #fdf0e9;
}

.page-section-select-size-active>.page-section-select-text {
    color: #202020 !important;
}

.page-section-select-text {
    font-weight: 600;
    font-size: 1.1em;
    color: #202020;
    margin-left: 1vw;
}

.page-section-select-size:hover>.page-section-select-text {
    color: var(--primary-color);
}

.active-icon {
    color: var(--primary-color) !important;
}

.desactive-icon {
    color: var(--primary-color);
}

.page-title {
    margin-top: 45px;
    font-weight: 700;
    font-size: 2.72em;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #605F5F;
}

.page-title-print {
    display: none;
}

.page-table-line-special {
    background: #F7F7F7;
}

/* Participation Progress Bar Styles */
.participation-container {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
}

.participation-bar {
    flex: 1;
    height: 8px;
    background-color: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    min-width: 40px;
}

.participation-fill {
    height: 100%;
    background: linear-gradient(90deg, #FF5722, #ffab66);
    border-radius: 4px;
    transition: width 0.3s ease;
    min-width: 2px;
}

.participation-text {
    font-size: 0.85em;
    font-weight: 600;
    color: #605F5F;
    min-width: 35px;
    text-align: right;
}

@media only screen and (max-width: 1000px) {
    .page {
        font-size: 1.2vw;
    }
}

@media only screen and (max-width: 800px) {
    .page {
        font-size: 2vw;
    }

    .page-table-header {
        display: none;
    }

    .mobile {
        display: block;
    }

    .checkbox-container {
        width: 100%;
        justify-content: space-around;
        margin-top: 3vw;
    }

    .align-end {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .alert-container {
        width: 100%;
        padding: 1vh 0.5vw;
        font-size: 18px;
    }

    .desktop {
        display: none !important;
    }

    .page-filter-containears {
        flex-direction: column;
    }

    .page-filter-search {
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .page-filter-status {
        margin-bottom: 20px;
    }

    .page {
        padding: 0 5vw;
    }

    .page-head-buttons {
        flex-direction: column;
        gap: 2vh;
    }

    .page-head-buttons-group {
        flex-wrap: wrap;
        gap: 2vh 0;
        justify-content: space-between;
        width: 100%;
    }

    .page-head-button-email {
        width: 45%;
    }

    .page-table-line {
        flex-direction: column;
        gap: 1vh;
        font-size: 1.2em;
    }

    .page-table-separator {
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex: unset;
    }

    .page-mobile-header {
        display: flex;
        font-size: 1em;
        font-weight: 700;
    }

    .page-table-actions-width {
        flex: unset;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-left: 10px;
    }

    .page-table-city-width {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .seller-participation-icon {
        width: 40%;
        font-size: 1em;
        padding: 0;
    }

    .seller-table-mobile-align {
        text-align: end;
        font-weight: bold;
        font-size: 1.1em;
    }

    .page-table-phone-width {
        padding-left: 10px;
    }

    .page-table-status-width {
        padding-left: 10px;
    }

    .page-table-separator {
        border-right: none;
        padding-right: 2vw;
    }

    .mobile-row-table {
        display: flex !important;
        justify-content: space-between;
        width: 100%;
    }

    .page-table-expand-width {
        width: 100%;
        justify-content: flex-start;
    }

    .table-select-container {
        justify-content: space-evenly;
        gap: 0;
    }

    .table-select-button {
        width: 35%;
        padding: 2vh 0;
    }

    /* Mobile styles for participation progress bar */
    .participation-container {
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
    }

    .participation-bar {
        width: 100%;
        height: 6px;
    }

    .participation-text {
        font-size: 0.9em;
        min-width: auto;
        text-align: left;
    }
}

@media only screen and (max-width: 500px) {
    .page {
        font-size: 3vw;
    }
}

@media only print {
    .page-route-select {
        display: none;
    }

    .page-title {
        display: none;
    }

    .page-table-expand-icon {
        display: none;
    }

    .page-title-print {
        display: block;
        text-align: center;
        margin: 1vh 0;
        margin-top: 45px;
        font-weight: 700;
        font-size: 2.72em;
        line-height: 24px;
        letter-spacing: 0.15px;
        color: #605F5F;
    }

    .page-head-buttons {
        display: none;
    }

    .page-filter-containears {
        display: none;
    }

    .pagination {
        display: none;
    }

    .page-table-actions-width {
        display: none;
    }

    .page-table-state-width {
        width: unset;
        flex: 1;
    }

    .page-table-header {
        margin-top: 0;
    }

    .print-logo-container {
        display: flex !important;
        justify-content: center;
        margin-top: -20vh;
    }

    .print-only {
        display: block;
    }

    .page-table-line {
        display: flex;
        font-size: 1.1em;
        padding: 0;
    }

    .page-table-header {
        display: flex;
    }
}
</style>
